<style lang="less">
  .intermediate,.intermediateM{
    width: 375px;
    height: auto;
    margin :auto;
    background: url('/s/publesson/images/bg_body.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    color: #696464;
    padding: 0px 0 50px 0;
    font-size: 12px;
    .page{
      .lesson{
        width:100%;
        margin :auto;
        background-size: 100% 100%;
        text-align:center;
        font-size: 16px;
        position: relative;
        padding-top: 28px;
        .lessonInfo{
          width:100%;
          background: url('/s/publesson/images/bg_cover_title_middle.png');
          background-size: 100% 100%;
          text-align:center;
          padding: 13px 0 11px 0;
          color:#418869;
          position: relative; 
          &:before {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            top: -28px;
            height: 28px;
            background: url('/s/publesson/images/bg_cover_title_top.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
          .comma {
            position: absolute;
            top: 0;
            right: 28px;
            width: 60px;
            height: 52px;
            background: url('/s/publesson/images/comma.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
          }
          .lessonName{
            width: 280px;
            margin: auto;
            font-size: 21px;
            font-weight: bolder;
            position: relative;
            z-index: 1;
            word-wrap: break-word;
          }
          .lessonStartTime{
            margin-top: 8px;
          }
        }
        .lessonTeacher{
          width:100%;
          height:62px;
          background: url('/s/publesson/images/bg_cover_title_bottom.png');
          background-size: 100% 100%;
          color: #418869;
          .teacher{
            height:24px;vertical-align: middle;display: inline-block;
          }
          .avatarImg{
            position: relative;
            display: inline-block;width: 28px;
            margin-right:7px;
            .avatar{
              width: 28px;
              display: inline-block;
              vertical-align: bottom;
              margin-bottom: -6px;
            }
            .avatarBorder{
              position: absolute;
              width: 28px;
              height: 28px;
              display: inline-block;
              background: url(/s/publesson/images/avatar_border.png);
              background-size: 100% 100%;
              text-align: center;
              left: 0px;top: 0px;
            }
          }
          .teacherName{
            display: inline-block;
            height:24px;
            max-width: 100px;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            vertical-align: middle;
            // line-height:24px;
          }
          .duration{
            margin-left: 12px;
            display: inline-block;
            height:24px;
            vertical-align: middle;
          }
        }
        .lessonContent{
          font-size: 15px;
          color:#999;width:100%;
          background: url('/s/publesson/images/bg_border_cover_body.png');
          background-size: 100% 100%;
          text-align:center;
          margin: auto;
          padding:22px 0 160px 0;
          position: relative;
          .tip{
            width: 275px;
            margin: auto;
            margin-top: 10px;
          }
          .copy{
            margin: auto;
            width: 200px;
            height:60px;
            border-left:1px solid #84DDB6;
            border-right:1px solid #84DDB6;
            border-bottom:3px solid #84DDB6;
            border-radius: 3px;
            box-shadow: 0px 1px 1px 0px rgba(132,221,182,1);
            box-sizing: content-box;
            position: relative;
            margin-top: 45px;
            color:#11C577;
            .clickCopy{
              position: absolute;
              top: -11px;left: 0;
              width: 100%;
              -webkit-touch-callout: none;
              -webkit-user-select: none;
              -khtml-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              user-select: none;
            }
            .circle{
              display: inline-block;
              width: 23px;
              border-top:1px solid #84DDB6;
              position: absolute;
              &:before{
                content: '';
                display: inline-block;
                width: 4px;height:4px;
                background: #84DDB6;
                border-radius:50%;
                position: absolute;
              }
            }
            .left{
              left: 0;
              &:before{
                right: 0;
                top: -2px;
              }
            }
            .right{
              right: 0;
              &:before{
                left: 0;
                top: -2px;
              }
            }
            .publessonId{
              display: inline-block;
              height:30px;margin-top: 13px;
              // line-height: 59px;
              color: #0A824E;
              font-size: 28px;
              cursor: pointer;
              font-family: DIN-Medium;
            }
          }
        }
        .jumpPage{
          padding-top: 5px;
        }
        .lessonResultContent{
          .resultImg{
            width: 140px;
            height:105px;
            margin:auto;
            // margin-top:40px;
          }
          .context{
            text-align:center;
            font-size: 20px;
            color:#696464;
            margin-top:20px;
            margin-bottom: 5px;
            font-weight: bolder;
          }
          .subtitle{
            width: 264px;
            margin: auto;
            color:#696464;
            margin-top: 16px;
          }
          span{
            text-align:center;
            font-size: 15px;
            color:#696464;
          }
        }
        .footerBorder{
          width:100%;height:40px;
          background: url('/s/publesson/images/bg_border_cover_footer.png');
          background-size: 100% 100%;
          text-align:center;
        }
      }
      .signUpByPhone{
        background-size: 100% 100%;
        text-align:center;
      }
      .introduction{
        text-align:center;
        width: 340px;
        margin: auto;
        margin-top:20px;
        .title{
          background: url("/s/publesson/images/icon_dot.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          position: relative;
          width: 278px;
          height: 19px;
          margin: auto;
          color:#fff;
          .bgtext{
            position: absolute;
            font-size: 40px;
            color:#FFFFFF;
            opacity: 0.2;
            font-weight: 300;
            left: 50%;top: -8px;
            transform: translateX(-50%);
            -webkit-transform: translateX(-50%);
          }
          .titleText{
            position: absolute;
            font-size: 28px;
            text-align: center;
            left: 50%;top: -11px;
            transform: translateX(-50%);
            -webkit-transform: translateX(-50%);
          }
        }
        .whiteBoard{
          width:100%;margin: auto;
          border-radius: 8px;
          padding: 23px 18px;
          background: #fff;
          box-shadow: 0px 15px 15px 0px rgba(0,0,0,.1);
          margin-top:40px;
          word-wrap: break-word;
          word-break: break-all;
          p {
            text-align: left;
            line-height: 1.5;
            img {
              max-width: 100% !important;
              text-align: center;
              display: inline-block;
            }
          }
        }
      }
    }
    .submitBtn{
      display: block;
      width: 264px;height: 44px;
      margin: auto;
      border-radius: 25px;
      line-height: 44px;
      color: #fff;
      cursor: pointer;
      box-shadow: 4px 4px 8px 0px rgba(28,148,69,.3);
      font-size: 18px;
      -webkit-user-select:none;
      -moz-user-select:none;
      -ms-user-select:none;
      user-select:none;
      border: 0;
      outline: none;
      background-color: #11C879;
      margin-top: 52px;
      position: absolute;
      z-index: 2;
      left: 50%;
      transform: translateX(-50%);
      -webkit-transform: translateX(-50%);
    }
  }
  .intermediateM{
    position: absolute;
    width: 100vw;
    min-height: 100vh;
    padding: 0px 0 100px 0;
    background-position:0px -1px;
    box-sizing: border-box;
    font-size: 24px;
    left: 0;right: 0;
    top: 0;
    .page{
      .lesson{
        font-size: 32px;
        box-sizing: border-box;
        padding-top: 56px;
        .lessonInfo{
          padding: 26px 0 22px 0;
          &:before {
            height: 56px;
            top: -55px;
          }
          .comma {
            right: 56px;
            width: 120px;
            height: 104px;
          }
          .lessonName{
            width: 560px;
            font-size: 42px;
          }
          .lessonStartTime{
            margin-top: 16px;
          }
        }
        .lessonTeacher{
          height:124px;
          margin-top: -1px;
          .teacher{
            height:48px;
          }
          .avatarImg{
            width: 58px;
            margin-right:14px;
            .avatar{
              width: 56px;
            }
            .avatarBorder{
              width: 58px;
              height: 58px;
              left: 0px;
              top: -1px;
            }
            .avatar{
              height:56px;
              margin-bottom: -8px;
            }
          }
          .teacherName{
            max-width: 200px;
            height:48px;
          }
          .duration{
            margin-left: 48px;
            height:48px;
          }
        }
        .lessonContent{
          font-size: 30px;
          padding: 44px 0 320px 0;
          margin-top: -1px;
          .tip{
            width: 550px;
            margin-top: 20px
          }
          .copy{
            width: 400px;
            height:120px;
            border-left:1px solid #84DDB6;
            border-right:1px solid #84DDB6;
            border-bottom:6px solid #84DDB6;
            border-radius: 6px;
            box-shadow: 0px 1px 1px 0px rgba(132,221,182,1);
            margin-top: 90px;
            .clickCopy{
              top: -22px;
            }
            .circle{
              width: 46px;
              border-top:1px solid #84DDB6;
              &:before{
                width: 8px;height:8px;
              }
            }
            .left:before,.right:before{
              top: -4px;
            }
            .publessonId{
              height:60px;
              margin-top: 30px;
              font-size: 56px;
            }
          }
        }
        .lessonResultContent{
          .resultImg{
            width: 280px;
            height:210px;
            // margin-top:80px;
          }
          .context{
            font-size: 40px;
            margin-top:40px;
            margin-bottom: 10px;
          }
          .subtitle{
            width: 528px;
            color:#696464;
            margin-top: 32px;
          }
          span{
            font-size: 30px;

          }
        }
        .footerBorder{
          height:80px;
          margin-top: -1px;
        }
      }
      .signUpByPhone{
        // height:1200px;
      }
      .introduction{
        width: 680px;
        margin-top:40px;
        .title{
          width: 556px;
          height: 38px;
          .bgtext{
            font-size: 80px;
            top: -16px;
          }
          .titleText{
            font-size: 56px;
            top: -22px;
          }
        }
        .whiteBoard{
          border-radius: 16px;
          padding: 46px 36px;
          box-shadow: 0px 30px 30px 0px rgba(0,0,0,.1);
          margin-top:80px;
          font-size: 24px;
        }
      }
    }
    .submitBtn{
      width: 528px;height: 88px;
      border-radius: 50px;
      line-height: 88px;
      box-shadow: 8px 8px 16px 0px rgba(28,148,69,.3);
      font-size: 36px;
      margin-top: 104px;
    }
  }
 
</style>
<template>
  <div v-if="ajaxReturn" :class="isMobile?'intermediateM':'intermediate'" @click="handle">
    <div class="page" >
      <div class="lesson" :class="{signUpByPhone:usePhone}">
        <div class="lessonInfo">
          <p class="comma"></p>
          <p class="lessonName">{{lessonInfo.lessonName?lessonInfo.lessonName:'-'}}</p>
          <p class="lessonStartTime">
            <span v-if="lessonInfo.lessonStartTime">
              {{lessonInfo.lessonStartTime|moment_format('YYYY-MM-DD dddd HH:mm')}}
            </span>
            <span v-else>--</span>
          </p>
        </div>
        <div class="lessonTeacher">
          <span class="teacher">{{$t('publesson.teacher')}}</span>
          <span  class="avatarImg">
            <img v-if="lessonInfo.teacherLogo" :src="lessonInfo.teacherLogo|serverimg_url('50x50')"
            class="avatar">
            <img v-else src="/s/publesson/images/avatar_defalut.png" class="avatar">
            <span class="avatarBorder">
            </span>
          </span>
          <span class="teacherName">{{lessonInfo.teacherName}}</span>
          <div class="duration">
            {{$t('publesson.duration')}}
            <span v-if="lessonInfo.druation">
              {{lessonInfo.druation | moment_format('mm','durationHumanize')}}{{$t('publesson.minute')}}
            </span>
            <span v-else>-</span>
          </div>
        </div>
        <!-- 报名 -->
        <div v-if="lessonInfo.signUpStatus===''" class="lessonContent" :style="{paddingTop:usePhone?'0px':(isMobile?'44px':'22px')}">
          <!-- 手机号报名 -->
          <signUpByPhone v-if="usePhone"
            ref="signUpByPhone"
            @signUp="signUp"
            @routerTo="routerTo"
            :config="signUpByPhoneConfig">
          </signUpByPhone>
          <div v-else>
            <p class="tip" v-html="$t('publesson.clickSignUp')"></p>
            <p class="copy">
              <span class="circle left"></span>
              <span class="circle right"></span>
              <span class="clickCopy">{{isMobile?$t('publesson.pressPublessonId'):$t('publesson.copyPublessonId')}}</span>
              <span class="publessonId" @click="isMobile?'':strCopy(publessonId)">{{publessonId}}</span>
              <textarea id="input" ref="input" style="display: none"></textarea>
            </p>
            <div class="submitBtn primary" @click="signUpNow">{{$t('publesson.applyNow')}}</div>
          </div>
          <dot></dot>
        </div>
        <div v-if="lessonInfo.signUpStatus==='jumpPage'" class="lessonContent jumpPage">
          <jumppage :jumpInfo="jumpInfo"></jumppage>
          <dot></dot>
        </div>
        <!-- 课程结束 -->
        <div v-show="lessonInfo.signUpStatus==='lessonEnd'" class="lessonContent lessonResultContent">
          <img class="resultImg" src="/s/publesson/images/tip_end.png">
          <p class="context">{{$t('publesson.end')}}</p>
          <p class="subtitle" v-html="$t('publesson.subtitle.downAndReady')"></p>
          <div data-id="classInDownLoad_auto" class="submitBtn primary">{{$t('publesson.down')}}</div>
          <dot></dot>
        </div>
        <!-- 报名满 -->
        <div v-show="lessonInfo.signUpStatus==='lessonStuFull'" class="lessonContent lessonResultContent">
          <img src="/s/publesson/images/tip_end.png" class="resultImg lessonEnd">
          <p class="context">{{$t('publesson.full')}}</p>
          <div data-id="classInDownLoad_auto" class="submitBtn primary">{{$t('publesson.down')}}</div>
          <dot></dot>
        </div>
        <!-- 报名成功 -->
        <div v-show="lessonInfo.signUpStatus==='signUpSuccess'"
          class="lessonContent lessonResultContent signUpSuccess">
          <img src="/s/publesson/images/tip_success.png" class="resultImg lessonEnd">
          <p class="context" style="color:#11C879;">{{$t('publesson.success')}}</p>
          <p class="subtitle" v-html="$t('publesson.subtitle.downAndinstall')"></p>
          <div data-id="classInDownLoad_auto" class="submitBtn primary">{{$t('publesson.down')}}</div>
        <!-- <div v-if="lessonInfo.signUpStatus==='signUpSuccess'"
          class="lessonContent lessonResultContent subtitle">
          <img src="/s/publesson/images/tip_success.png" class="resultImg lessonEnd">
          <p class="context" style="color:#11C879;">{{$t('publesson.success')}}</p>
          <p class="subtitle" v-html="$t('publesson.subtitle.downAndinstall')"></p>
          <a class="submitBtn primary" target="_blank" :href="deviceTypeUrl">{{$t('publesson.down')}}</a> -->
          <dot></dot>
        </div>
        <div class="footerBorder"></div>
      </div>
      <!-- 机构简介 -->
      <div class="introduction"
        v-if="(lessonInfo.signUpStatus===''||lessonInfo.signUpStatus==='signUpSuccess')&&lessonInfo.schoolIntroduction">
        <p class="title">
          <span class="bgtext">introduction</span>
          <span class="titleText">{{$t('publesson.institution')}}</span>
        </p>
        <div class="whiteBoard" v-html="lessonInfo.schoolIntroduction">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import qs from 'qs';
  import url from 'url';
  import moment from 'moment';
  import moment_format      from '@/filters/moment_format';
  import serverimg_url      from '@/filters/serverimg_url';
  import html_text_mobile   from '@/filters/html_text_mobile';
  import strCopy            from '@/api/strcopy';
  import signUpByPhone      from '@/components/publesson/signup_byphone.vue';
  import dot                from '@/components/publesson/content_dot.vue';
  import jumppage           from '@/components/publesson/jumppage.vue';
  import restful_publesson  from '@/api/publesson/restful_publesson.js';

  export default {
    components:{
      signUpByPhone,
      jumppage,
      dot
    },
    filters:{
     serverimg_url,
     moment_format,
     html_text_mobile
    },
    data(){
      return {
        isMobile: window.browserVersion.mobile,
        lessonKey: url.parse(window.location.href, true).query.lessonKey,
        publessonId: url.parse(window.location.href, true).query.classSN || 
                      url.parse(window.location.href, true).query.sn,
        clientName:'',
        lessonInfo:{
          lessonId:'',
          courseLogo:'',
          lessonName:'',
          lessonStartTime:'',
          teacherLogo:'',
          teacherName:'',
          druation:'',
          schoolIntroduction:'',
          signUpStatus:'',
        },
        usePhone: url.parse(window.location.href, true).query.usePhone,
        signUpByPhoneConfig:{
          lessonId:'',
        },
        deviceTypeUrl:'',
        inWeixin:false,
        errorNo:'',
        canClick:true,
        ajaxReturn:false
      }
    },
    watch:{
    },
    methods:{
      strCopy:strCopy,
      routerTo(pageName){
        this.$emit('routerTo','tippage');
      },
      handle(){
        if(this.$refs.signUpByPhone&&this.$refs.signUpByPhone.optionList){
          this.$refs.signUpByPhone.closeOptionList();
        }
      },
      changeMeta(shareDataConfig){
        document.title = shareDataConfig.title;

        var metaName = document.createElement("meta");
        metaName.setAttribute('itemprop', 'name');
        metaName.content = shareDataConfig.title;
        document.head.appendChild(metaName);

        var metaImg = document.createElement("meta");
        metaImg.name = "image";
        metaImg.setAttribute('itemprop', 'image');
        metaImg.content = shareDataConfig.imgUrl;
        document.head.appendChild(metaImg);

        var metaDesc = document.createElement("meta");
        metaDesc.name = "description";
        metaDesc.setAttribute('itemprop', 'description');
        metaDesc.content = shareDataConfig.desc;
        document.head.appendChild(metaDesc);
      },
      getShareData(resData){
        var logo = (resData.lessonInfoData.courseLogo)?serverimg_url(resData.lessonInfoData.courseLogo):'';
        var shareDataConfig = {
          title:this.$t('publesson.shareTitle',{lessonName:resData.lessonInfoData.lessonName}),
          desc: resData.lessonInfoData.schoolName,
          imgUrl:logo?(window.location.protocol + '//' + window.location.host + logo):'https://www.eeo.cn/images/webcast/weixin-share.png',
          tip:this.$t('publesson.shareTitleTip',{schoolName:resData.lessonInfoData.schoolName})
        }
        document.title = this.$t('publesson.applyPublesson');
        if(this.isMobile){
          this.changeMeta(shareDataConfig);
        }
        window.eeoWxShare(shareDataConfig);
      },
      getPublessonInfo(){
        this.$root.pageLoading(true);
        restful_publesson('getLessonInfo',{
            lessonKey: this.lessonKey,
            classSN: this.publessonId
          }).then((res)=>{
          this.$root.pageLoading(false);
          var resData = res.data;
          this.ajaxReturn = true;
          if(resData){
            if(typeof resData=='number'){
              this.errorNo = resData;
              switch (resData) {
                case 304:
                  window.meaasgeAlert(this.$t('publesson.tip.institutionDisabled'));
                  break;
                case 104:
                  this.$emit('routerTo','tippage',this.$t('publesson.tip.invalid'));
                  break;
                case 212:
                  this.$emit('routerTo','tippage',this.$t('publesson.tip.deleted'));
                  break;
                
              }
            }else{
              this.lessonInfo = resData.lessonInfoData;
              this.lessonInfo.schoolIntroduction = html_text_mobile(resData.lessonInfoData.schoolIntroduction);
              // this.lessonInfo.signUpStatus='lessonEnd'
              this.signUpByPhoneConfig.lessonId = resData.lessonInfoData.lessonId;
              this.getShareData(resData);
            }
          }
        })
      },
      signUp(status){
        this.lessonInfo.signUpStatus = status;
      },
      signUpNow(){
        if(this.lessonInfo.lessonName){
          var url = "classin://www.eeo.cn/enterclass?openClassId="+this.publessonId;
          if(window.browserVersion.mobile){
            this.browserMobile(url);
          }else{
            this.browserPc(url)
          }
        }else{
          this.isHaslessonName();
        }
      },
      browserMobile(url){
        if(!eeoRunWithoutWx()){
          return;
        }
        if(window.browserVersion.android){
          window.location.href = url;
          window.AppRoot.pageLoading();
          var time = setTimeout(()=>{
            window.AppRoot.pageLoading(false)
            window.location.href = window.location.href+"&usePhone=true";
          },3000);
        }
        if(window.browserVersion.ios){
          var hostnameStatic = window.EEOENV.hosts.static;
          var newUrl = window.location.href.replace(window.location.hostname,hostnameStatic)+"&usePhone=true";
          var time = setTimeout(()=>{
            window.location.href = newUrl;
          },200);
        }
      },
      browserPc(url){
        this.lessonInfo.signUpStatus='jumpPage';
        var callBack = ()=>{
          if (window.browserVersion.chrome) {
            window.location = url
          } else {
            var iframe = document.createElement("iframe");
            iframe.src = url;
            iframe.style.width ="0";
            iframe.style.height="0";
            iframe.style.display="none";
            document.body.appendChild(iframe);
            this.$nextTick(()=>{
              iframe.parentNode.removeChild(iframe);
            })
          }
        }
        eeoRunWithoutWx(callBack);
       // window.location.href = window.location.href+"&usePhone=true";
      },
      isHaslessonName(){
        if(this.canClick){
          switch (this.errorNo) {
            case 304:
              window.meaasgeAlert(this.$t('publesson.tip.institutionDisabled'));
              this.canClick = false;
              var timer = setTimeout(()=>{
                this.canClick = true;
              },1000)
              break;
          }
        }
      },
      getDevice(){
        var isiOS = window.browserVersion.ios;
        var isAndroid = window.browserVersion.android;
        if(isiOS){
          this.deviceTypeUrl='https://itunes.apple.com/app/id1226361488?mt=8'
        }else if(isAndroid){
          this.deviceTypeUrl='https://android.myapp.com/myapp/detail.htm?apkName=cn.eeo.classin&ADTAG=mobile'
        }else{
          this.deviceTypeUrl='https://www.eeo.cn/cn/download.html'
        }
      },
      isSupportIosVersion(){
        var ver=window.navigator.userAgent.toLowerCase().match(/cpu iphone os (.*?) like mac os/);
        var minVer = '9';
        var minVerArr = minVer.split('_');
        var currentVerArr = ver[1].split('_');
        var verLen = currentVerArr.length;
        while(minVerArr.length<verLen){
          minVerArr.push('0')
        }
        var isSupport = false;
        var i=0;
        var compare = function(minVer,currentVer){
          if(minVer<currentVer){
            isSupport = true;
          }else if(minVer>currentVer){
            isSupport = false;
          }
        }
        for (var i=0;i<verLen; i++) {
          if(minVerArr[i]*1 == currentVerArr[i]*1){
            if(i==verLen-1){
              isSupport = true;
            }else{
              compare(minVerArr[i]*1,currentVerArr[i]*1);
            }
          }else{
            compare(minVerArr[i]*1,currentVerArr[i]*1)
            return isSupport
          }
        }
        return isSupport
      },
    },
    computed:{
      jumpInfo(){
        var obj = {
          publessonId:this.publessonId
        };
        return obj
      }
    },
    mounted(){
      this.getPublessonInfo();
      this.getDevice();
      this.clientName = this.$root.clientName;
      this.inWeixin = window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger';
      if(this.usePhone){
        if(this.lessonKey){
          var backUrl = window.location.origin+window.location.pathname+'?lessonKey='+this.lessonKey+'&classSN='+this.publessonId;
        } else {
          var backUrl = window.location.origin+window.location.pathname+'?sn='+this.publessonId;
        }
        eeoRunWithoutWx(false,window.location.href);
      }
    }
  }
</script>